module.exports = __webpack_public_path__ + "img/13_Middle-D.705a8f73.png";